<template>
  <div class="dashboard-main-content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-lg-12" v-if="seaTourList != null">
          <div class="form-box">
            <div class="form-title-wrap">
              <div class="d-flex align-items-center justify-content-end">
                <a href="javascript:void(0)" :href="'/seatours/new'" class="theme-btn theme-btn-small">
<!--                <a href="javascript:void(0)" class="theme-btn theme-btn-small">-->
                  <i class="la la-plus mr-1"></i>
                  Tur Yarat
                </a>

              </div>
            </div>
            <div class="form-content pb-2">

              <h3 class="title">Turlar</h3>
              <p class="font-size-14">{{ seaTourList.length }} tur listeleniyor</p>

              <div class="table-form table-responsive">
                <table class="table">
                  <thead>
                  <tr>
                    <th scope="col">#</th>
                    <th>Adı</th>
                    <th>Kodu</th>
                    <th>Vize Gerekliliği</th>
                    <th>Resim</th>
                    <th></th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="seatTour in seaTourList">
                    <th scope="row"><a :href="basePath+'/seatours/'+seatTour.id">#{{seatTour.id}}</a></th>
                    <th>{{ seatTour.name }}</th>
                    <th>{{ seatTour.tourCode }}</th>
                    <th v-if="seatTour.visaRequired">✓</th>
                    <th v-if="!seatTour.visaRequired">x</th>
                    <th>
                      <big-image-component v-if="seatTour.imageUrl != null" :url="seatTour.imageUrl"></big-image-component>
                    </th>
                    <td>
                      <div class="row">
                        <div class="table-content mr-2" v-on:click="deleteSeaTour(seatTour)">
                          <a href="javascript:void(0)" class="theme-btn theme-btn-small" data-toggle="tooltip" data-placement="top" title="" data-original-title="Delete">
                            <i class="la la-trash"></i>
                          </a>
                        </div>
                        <div class="table-content">
                          <a :href="basePath+'/seatours/'+seatTour.id" class="theme-btn theme-btn-small" data-toggle="tooltip" data-placement="top" title="" data-original-title="Edit">
                            <i class="la la-edit"></i>
                          </a>
                        </div>
                      </div>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BigImageComponent from "../common/BigImageComponent";
import messagePopupManager from "../../util/messagePopupManager";
import helper from "../../store/helper/cruiseStoreHelper";
export default {
  name: "SeaTourList",
  components: {BigImageComponent},
  computed:{
    seaTourList:{
      get(){
        return this.$store.getters.getSeaTourList;
      }
    },
    basePath:{
      get(){
        return this.$store.getters.getBasePath
      }
    }
  },
  methods : {
    deleteSeaTour(seaTour){
      messagePopupManager.showDeleteQuestion(() => {
        this.$store.dispatch("deleteSeaTour", seaTour).then(response => {
          messagePopupManager.showSuccess();
        })
        .catch(error => {
          helper.checkDeleteResponseCodeAndShowPopup(error.code);
        })
      })
    }
  },
  beforeCreate() {
    this.$store.dispatch("loadSeaTourList");
  }
}
</script>

<style scoped>

</style>